import { useTranslation } from "react-i18next";
import { Button } from "@/shared/components";
import { useAuth } from "@/auth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function LoginPage() {
  const { t } = useTranslation();
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth?.user) {
      navigate("/reports/summaries");
    }
  }, [auth?.user, navigate]);

  if (auth?.user !== undefined && auth?.user !== null) {
    return null;
  }

  const handleLogin = () => {
    if (import.meta.env.MODE === "development") {
      auth?.login();
    } else {
      window.location.href = "/login/cas";
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-8">
      <div className="bg-white rounded-lg shadow-lg text-center overflow-hidden">
        <div className="p-12">
          <p className="text-black text-base mb-6">
            {t("auth.loginMessageFirstParagraph")}
          </p>
          <p className="text-black text-base mt-0 mb-6">
            {t("auth.loginMessageSecondParagraph")}
          </p>
          <Button
            variant="primary"
            size="lg"
            className="hover:bg-primary-hover text-black border-none w-48 justify-center py-3"
            onClick={handleLogin}
          >
            {t("auth.login")}
          </Button>
        </div>
      </div>
    </div>
  );
}
